<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
// 默认开启:nil/true -> 开, false -> 关
const isEnabled = ref(true);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const val =
      currentAccount.value?.settings?.visitor_auto_conversation_enabled;
    isEnabled.value = val !== false;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(
      t('GENERAL_SETTINGS.FORM.VISITOR_AUTO_CONVERSATION.API.SUCCESS')
    );
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.VISITOR_AUTO_CONVERSATION.API.ERROR'));
  }
};

const toggleVisitorAutoConversation = async () => {
  return updateAccountSettings({
    visitor_auto_conversation_enabled: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.VISITOR_AUTO_CONVERSATION.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.VISITOR_AUTO_CONVERSATION.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleVisitorAutoConversation" />
      </div>
    </template>
  </SectionLayout>
</template>
